// src/api/blogs.js
// All blog-related HTTP calls live here.
// Components import these functions and call them; they never import axios directly.
//
// Why centralize:
// - Single source of truth: if the backend URL changes, only this file changes.
// - Clean component code: pages call getAllBlogs() instead of constructing axios calls.
// - Easier to mock or modify later (auth headers, retries, error wrapping).
//
// All paths are relative ("/api/blogs"). In development, src/setupProxy.js
// forwards these to http://localhost:3000. In production, Express serves both
// the React build and the API from the same origin, so relative paths just work.
//
// Each function returns response.data (the body), not the full axios response.
// Errors are not caught here; they propagate to the caller, which is better
// positioned to decide what to show the user.

import axios from "axios";

const BASE = "/api/blogs";

// GET /api/blogs: fetch all blogs.
export async function getAllBlogs() {
  const response = await axios.get(BASE);
  return response.data;
}

// GET /api/blogs/:id: fetch a single blog by ID.
export async function getBlogById(id) {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
}

// POST /api/blogs: create a new blog.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function createBlog(data) {
  const response = await axios.post(BASE, data);
  return response.data;
}

// PUT /api/blogs/:id: update an existing blog.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function updateBlog(id, data) {
  const response = await axios.put(`${BASE}/${id}`, data);
  return response.data;
}

// DELETE /api/blogs/:id: delete a blog.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function deleteBlog(id) {
  const response = await axios.delete(`${BASE}/${id}`);
  return response.data;
}
